import {AppConfig, BaseAppProps, BaseAppState} from "shared/BaseApp";
import React, {ReactElement} from 'react';
import {createTheme, ThemeOptions} from "@mui/material";
import {DEFAULT_THEME_OPTIONS} from "../shared/colors";
import {Main} from "./Main";
import {FIREBASE_CONFIG} from "../consts";
import {ProvisionedApp} from "../shared/ProvisionedApp";
import {ProvisionedAppConfig} from "../shared/types";
import "../res/css/App.css";
import {PathComponent} from "../index";

export type AppProps = BaseAppProps & {}

type AppState = BaseAppState & {}

export const COLOR_PRIMARY = "#eee";
export const COLOR_SECONDARY = "#ccc";

export const COLOR_BG1 = "#133";
export const COLOR_BG2 = "#122";

export const THEME_OPTIONS: ThemeOptions = {
  ...DEFAULT_THEME_OPTIONS,
  typography: {
    h1: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h2: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h3: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h4: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h5: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h6: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    fontSize: 17,
  },
  shape: {
    borderRadius: 0,
  },
  palette: {
    mode: "dark",
    primary: {
      main: COLOR_PRIMARY,
      contrastText: "#111",
    },
    secondary: {
      main: COLOR_SECONDARY,
      contrastText: "#111",
    },
    background: {
      default: COLOR_BG1,
      paper: COLOR_BG2,
    }
  },
};

const THEME = createTheme(THEME_OPTIONS);

export class AppRefs {

  constructor(readonly audio: HTMLAudioElement) {
  }
}

export class App extends ProvisionedApp<AppProps, AppState> {

  private static appRefs: AppRefs;

  static getAppRefs(): AppRefs {
    if (!App.appRefs) {
      App.appRefs = App.createAppRefs();
    }
    return App.appRefs;
  }

  private static createAppRefs() {
    return new AppRefs(document.getElementById("player") as HTMLAudioElement);
  }

  getProvisionedAppId(): string {
    return "chesslink";
  }

  getProvisionedAppConfig(): ProvisionedAppConfig | null {
    return null;
  }

  onCreateAppConfig(): AppConfig {
    return {
      name: "Chesslink",
      icon: "/icon.png",
      logo: "/logo192.png",
      stamp: "/stamp.png",
      defaultUserImage: "/images/default_user.png",
      loginConfig: {
        noLogin: true,
        guestLogin: true,
      },
      theme: THEME,
      firebaseConfig: {options: FIREBASE_CONFIG},
    };
  }

  static nestedPaths(): PathComponent[] {
    return Main.nestedPaths();
  }

  protected renderMain(): ReactElement {
    return <Main path={this.props.path} />;
  }
}
